import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { TellentAppsDataService } from '@core/tellent-data';
import { TellentHttpApiService } from '@core/tellent-http-legacy';
import { SkillEntity } from '@core/tellent-skills-types';
import { SeatKind } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class SkillsHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);
  private readonly appsService = inject(TellentAppsDataService);

  public fetchAvailableSkills(): Observable<SkillEntity> {
    return this.appsService.getAppBySeatKind(SeatKind.Grow).pipe(
      take(1),
      switchMap(app =>
        this.httpApi.get(`/positions/app/${app.guid}/skills`, null, { skipCompany: true }),
      ),
    );
  }
}
